module.exports = __webpack_public_path__ + "static/media/clock.e86bdcff.svg";